import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ftx_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (item) =>
  item?.storage_path ? `${process.env.REACT_APP_BACKEND_URL}/api/gallery/image/${item.id}` : item?.image_url;

export const eventImageUrl = (item) =>
  item?.storage_path ? `${process.env.REACT_APP_BACKEND_URL}/api/events/image/${item.id}` : item?.image_url;

export function formatApiError(detail, fallback = "Something went wrong. Please try again.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
